import { useEffect, useState, type RefObject } from 'react';

/**
 * Reads the current chapter (0-based) from the Snak's rendered footer counter ("01 / 08").
 * Observes the Snak from outside so its source stays untouched. Returns -1 until found.
 */
export function useSnakChapter(hostRef: RefObject<HTMLElement>) {
  const [chapter, setChapter] = useState(-1);

  useEffect(() => {
    const read = () => {
      const host = hostRef.current;
      if (!host) return;
      const counter = Array.from(host.querySelectorAll('button[aria-label="Open chapter menu"]')).find((b) =>
        /^\d{2}/.test(b.textContent?.trim() ?? '')
      );
      const index = counter ? parseInt(counter.textContent!.trim().slice(0, 2), 10) - 1 : -1;
      setChapter((prev) => (prev === index ? prev : index));
    };
    read();
    const id = window.setInterval(read, 300);
    return () => window.clearInterval(id);
  }, [hostRef]);

  return chapter;
}
